// extracted by mini-css-extract-plugin
module.exports = {"textGalleryModuleContainer":"TextGalleryModule_textGalleryModuleContainer__1LjOv"};